import CollectGraphicsGrid from "./collect-graphics-grid";

export default CollectGraphicsGrid;